import PropTypes from 'prop-types'
import {SliderThumb} from '@mui/material/Slider'
import {StyledSlider, StyledTooltip} from './ColorSliderStyles'
import {Box, Typography} from '@mui/material'
const ColorSlider = ({onChange, onChangeCommit, value}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <Typography color='black' tabIndex={0} aria-label='Risk Range Slider' sx={{marginLeft: '-5px', fontSize: '14px'}}>
        Risk Range
      </Typography>
      <StyledSlider
        onChangeCommitted={onChangeCommit}
        aria-valuemax={100}
        aria-valuemin={0}
        onChange={onChange}
        value={value}
        marks
        valueLabelDisplay='auto'
        step={10}
        slots={{thumb: ThumbComponent, valueLabel: ValueLabelComponent}}
        getAriaLabel={(index) => (index === 0 ? 'Minimum' : 'Maximum')}
        getAriaValueText={() => 'value'}
        defaultValue={[0, 100]}
        disableSwap
      />
    </Box>
  )
}

export default ColorSlider

function ThumbComponent(props) {
  const {children, ...other} = props
  return (
    <SliderThumb {...other}>
      {children}
      <span className='triangle' />
    </SliderThumb>
  )
}

ThumbComponent.propTypes = {
  children: PropTypes.node
}

function ValueLabelComponent(props) {
  const {children, value} = props

  return (
    <StyledTooltip enterTouchDelay={0} placement='top' title={value} style={{borderRadius: '14px'}}>
      {children}
    </StyledTooltip>
  )
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired
}

ColorSlider.propTypes = {
  onChange: PropTypes.func,
  onChangeCommit: PropTypes.func,
  value: PropTypes.array
}
